<template>
  <v-carousel
    v-model="model"
    cycle
    id="carousel"
    style="background-color: #0e355c"
    height="auto"
  >
    <v-progress-circular
      indeterminate
      class="loading"
      color="white"
      v-if="loading"
    >
      Cargando
    </v-progress-circular>
    <v-carousel-item v-else id="item" v-for="guide in guides" :key="guide.id">
      <guide :id="guide.id" style="margin-top: 3%" :guide="guide"></guide>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import guide from "@/components/guideComponent.vue";
import { getGuides, getGuideFile } from "@/utils/apiRequest.js";
import FileSaver from "file-saver";
/* import pdf from "vue-pdf"; */
export default {
  data() {
    return {
      editedItem: {},
      guideList: new Map(),
      nameList: [],
      model: 0,
      guideSelected: "",
      guide: {},
      guides: [],
      loading: true,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Nombre", value: "name" },
        { text: "Tipo", value: "type" },
        { text: "", value: "controls" },
      ],
    };
  },
  components: {
    guide,
  },
  methods: {
    async downloadFile(item) {
      let response = await getGuideFile(item.id);
      FileSaver.saveAs(response.data, item.name);
    },
    async GetFileString(option) {
      this.guide = this.guideList.get(option);
    },
  },

  async mounted() {
    let response = await getGuides();
    if (response.data) {
      if (response.data.status == "success") {
        response.data.guide.forEach((guide) => {
          let name = guide.name.replace("." + guide.type, "");
          this.guideList.set(name, guide);
          this.guides.push(guide);
          this.nameList.push(name);
        });
      }
    }

    this.loading = false;
  },
};
</script>

<style scoped>
.v-carousel__item {
  height: 1000px;
}

.loading {
  position: absolute;
  left: 50%;
  margin: 15% 0 0 0;
  color: white;
}
</style>